import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { IconButton, InputAdornment, InputBase, SxProps } from '@mui/material';
import { useState } from 'react';

const sizetMap = {
    medium: {
        height: 48,
        width: 240,
    },
    large: {
        height: 56,
        // width: 360,
    },
};

export type SearchProps = {
    searchPlacholder: string;
    size?: 'medium' | 'large';
    onSubmit?: (value: string) => void;
    value?: string;
    initialValue?: string;
    onChange?: (value: string) => void;
    sx?: SxProps;
};

const Search = ({
    searchPlacholder,
    size = 'large',
    onChange,
    onSubmit,
    initialValue,
    sx,
    ...props
}: SearchProps) => {
    const [controledValue, setControledValue] = useState(initialValue || '');

    const searchValue = 'value' in props ? props.value : controledValue;

    return (
        <InputBase
            sx={{
                height: sizetMap[size].height,
                borderRadius: 50,
                backgroundColor: 'surfaceContainerHigh.main',
                ...sx,
            }}
            placeholder={searchPlacholder}
            value={searchValue}
            onChange={e => {
                setControledValue(e.target.value);
                onChange?.(e.target.value);
            }}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                    onSubmit(searchValue);
                }
            }}
            startAdornment={
                <InputAdornment position="end">
                    <IconButton onClick={() => onSubmit(searchValue)}>
                        <SearchRounded />
                    </IconButton>
                </InputAdornment>
            }
            endAdornment={
                <InputAdornment position="start">
                    <IconButton
                        onClick={() => {
                            setControledValue('');
                            onChange?.('');
                            onSubmit('');
                        }}
                    >
                        <CloseRounded />
                    </IconButton>
                </InputAdornment>
            }
        />
    );
};

export default Search;
